export const SUBAFFILIATE_HISTORY_CHANGES_EDIT_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.subaffiliate-condition.history-changes-edit');

export const TRANSLATION_GROUP_SUBAFFILIATE_HISTORY_CHANGES_EDIT = Symbol('admin.affiliates.approved.trackers-settings.subaffiliate-condition.history-changes-edit');

export const SUBAFFILIATE_HISTORY_CHANGES_ITEM_QUERY = 'affiliate.subaffiliate-condition.history-changes-item';
export const SUBAFFILIATE_HISTORY_CHANGES_ITEM_API_URL = 'admin/history_of_subaffiliates_changes/:itemId/edit';

export const SUBAFFILIATE_HISTORY_CHANGES_ITEM_UPDATE_MUTATION = 'affiliate.subaffiliate-condition.history-changes-item-update';
export const SUBAFFILIATE_HISTORY_CHANGES_ITEM_UPDATE_API_URL = 'admin/history_of_subaffiliates_changes/:itemId';
